import React, { useEffect } from 'react';
import '../asset/home.css'
import { Image, Card,Header, Container, Divider,Grid } from 'semantic-ui-react'
import userEvent from '@testing-library/user-event';

export default function Home(){
    const [deviceMode,setDeviceMode] = React.useState('none')
    const handleScreen = () => {
        const mediaMatchPortrait = window.matchMedia('(orientation: portrait)')
        const mediaMatchLanscape = window.matchMedia('(orientation: landscape)')
        const mediaMatchMobilePortrait = window.matchMedia('(max-width: 480px)');
        const mediaMatchMobileLanscape = window.matchMedia('(min-width: 480px) and (max-width: 900px) and (orientation: landscape)');
        const mediaMatchTabletLanscape = window.matchMedia('(min-width: 900px)');
        const mediaMatchTabletPortrait = window.matchMedia('(min-width: 480px) and (max-width: 900px) and (orientation: portrait)');
        
        if(mediaMatchMobilePortrait.matches){
            setDeviceMode('mobilePortrait')
        }
        
        if(mediaMatchMobileLanscape.matches){
            setDeviceMode('mobileLandScape')
        }
    
        if(mediaMatchTabletLanscape.matches){
            setDeviceMode('tabletLandScape')
        }
    
        if(mediaMatchTabletPortrait.matches){
            setDeviceMode('tabletPortrait')
        }
    
        mediaMatchTabletPortrait.addEventListener("change", e => {
          console.log("onListernerTabletPortrait: ",e.matches,e.media)
          if(e.matches){
            setDeviceMode('tabletPortrait')
          }
        })
    
        mediaMatchMobilePortrait.addEventListener("change", e => {
          console.log("onListernerMobilePort: ",e.matches,e.media)
          if(e.matches){
            setDeviceMode('mobilePortrait')
          }
        })
    
        mediaMatchMobileLanscape.addEventListener("change", e => {
          console.log("onListernerMobileLand: ",e.matches,e.media)        
          if(e.matches){
            setDeviceMode('mobileLandScape')
          }
        })
    
        mediaMatchTabletLanscape.addEventListener("change", e => {
          console.log("onListernerTabletLand: ",e.matches,e.media)
          if(e.matches){
            setDeviceMode('tabletLandScape')
          }
        })
      }
    
      useEffect(()=>{
          handleScreen()
      })
      
    return(
        // <Header>Test Home</Header> 
        <Grid id="gridHome">
            <Grid.Row id="gridHead">
                <Header id="fontHeader">PICK AT HOME</Header>
                <Header id="fontSub">free home pick-up logistic service application for entrepreneur</Header>
            </Grid.Row>
            {
                deviceMode == "mobilePortrait" ?
                <Divider style={{marginTop: '2vw',marginInline: '12vw'}} /> :
                <Divider style={{marginInline: '10vw',marginTop: '2vw'}}/>
            }
            
            <Grid.Row>
                {
                    deviceMode == "tabletLandScape" || deviceMode == "mobileLandScape" ?
                    <>
                    <Grid.Column id="gridImage" width={deviceMode == "tabletLandScape" ? 6 : deviceMode == "mobileLandScape" ? 7 : 8}>
                    <Image src='pahlogo.JPG' id="imgLogo"/>
                </Grid.Column>
                <Grid.Column id="gridDetail" width={deviceMode == "tabletLandScape" ? 10 : deviceMode == "mobileLandScape" ? 9 :8}>
                    <Header id="fontDetail">
                        แอพพลิเคชั่นสำหรับช่วยเหลือการขนส่งสินค้า เราสามารถไปรับพัสดุของคุณถึงที่บ้านและส่งให้ถึงบริษัทขนส่งโดยที่คุณไม่ต้องออกไปไหนเพียงแค่ใช้แอพพลิเคชั่นเราเท่านั้น
                    </Header>
                    <Grid.Row id="rowLink">
                        <label id="fontLink"><a href='https://apps.apple.com/us/app/pick-at-home/id1561010121'>Download App</a></label>
                        <label id="fontLink"> | </label>
                        <label id="fontLink" ><a href='/policy'>Privacy Policy</a></label>
                    </Grid.Row>
                    <Grid.Row id="rowLink" style={{justifyContent:'center'}}>
                        <label id="fontLink"> Contact us: </label>
                        <Image src='line-480.png' style={{width: '4vw',height: '4vw',marginTop: '0.5vw'}} 
                        href='https://line.me/ti/p/llKzm-X8dT'
                        />
                        <Image src='facebook-480.png' style={{width: '4vw',height: '4vw',marginTop: '0.5vw'}}
                        href='https://www.facebook.com/Pickathomee'
                        />
                    </Grid.Row>               
                </Grid.Column>
                </> : deviceMode == "mobilePortrait" || deviceMode == "tabletPortrait" ? 
                <>
                 <Grid.Column id="gridImage" width={16}>
                    <Image src='pahlogo.JPG' id="imgLogo"/>
                </Grid.Column>
            <Grid.Column id="gridDetail" width={16}>
                <Header id="fontDetail">
                    แอพพลิเคชั่นสำหรับช่วยเหลือการขนส่งสินค้า เราสามารถไปรับพัสดุของคุณถึงที่บ้านและส่งให้ถึงบริษัทขนส่งโดยที่คุณไม่ต้องออกไปไหนเพียงแค่ใช้แอพพลิเคชั่นเราเท่านั้น
                </Header>
                <Grid.Row id="rowLink">
                    <label id="fontLink"><a href='https://apps.apple.com/us/app/pick-at-home/id1561010121'>Download App</a></label>
                    <label id="fontLink"> | </label>
                    <label id="fontLink" ><a href='/policy'>Privacy Policy</a></label>
                </Grid.Row>    
                <Grid.Row id="rowLink">
                        <label id="fontLink"> Contact us: </label>
                        <Image src='line-480.png' style={{width: '5vw',height: '5vw',marginTop: '0.5vw'}} 
                        href='https://line.me/ti/p/llKzm-X8dT'
                        />
                        <Image src='facebook-480.png' style={{width: '5vw',height: '5vw',marginTop: '0.5vw'}}
                        href='https://www.facebook.com/Pickathomee'
                        />
                </Grid.Row>               
            </Grid.Column>
            </> : <></>
                }
               
            </Grid.Row>
        </Grid>
  
    )
}